import axios from "axios";
import authHeader from "./services/auth-header";

// axios.defaults.baseURL = "http://127.0.0.1:8000/api";
axios.defaults.baseURL = "https://backend.rocketfootwear.com/api";

axios.interceptors.request.use((config) => {
  config.headers = { 
    ...config.headers, 
    ...authHeader(),
    "Accept-Language": localStorage.getItem("admin_locale") === "ar" ? "ar" : "en"
  };
  return config;
});

export default axios;

